import * as Sentry from "@sentry/vue";
import Vue from "vue";

export function initializeSentry({environment}) {
    return Sentry.init({
        Vue,
        environment,
        dsn: "https://5bfebb2d6b0f441e823e6174b7a94683@o65997.ingest.sentry.io/4505544134295552",
        integrations: [
            // new Sentry.BrowserTracing({
            //     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            //     tracePropagationTargets: ["localhost", "https:yourserver.io/api/"],
            //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            // }),
            new Sentry.Replay(),
        ],
        // // Performance Monitoring
        // tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}
